export default {
    methods: {
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
          }
    }
}